/*
      .-.      ___
     (o.o)    (_ _)
      |=|      | |____....----....____         _ 
     __|__     | |\    Warning     . .~~~~---~~ |
   //.=|=.\\   | | |    this file is a mess   . |
  // .=|=. \\  | | |   --= '|/_/_( /|  arrrgh!  |
  \\ .=|=. //  | | |                   ..|
   \\(_=_)//   | | |..:::::::\\/     --...::::::|
    (:| |:)    | |/:::''''~~~~''''::::::::::::''~
     || ||     | |        ''`'         ~~~~~
     () ()     | |
     || ||
     || ||
    ==' '==

TODO
1. fix commented functions that were mutating state directly
2. abstract modular parts into their own components/state to reduce re-renders
3. fix styling & replace bs with tailwind
*/
import useCollectionsViewModel from './CollectionsViewModel'

import IndeterminateLoadingBar from '@components/shared/IndeterminateLoadingBar'
import { CollectionsRow } from '@components/collection/CollectionsRow'
import { AssignCollectionToUser } from '@components/collection/AssignCollectionToUser'
import CollectionRunsheetPersistFlow, { STEPS } from '../shared/CollectionRunsheetPersistFlow'
import Checkbox from '$components/Forms/Checkbox'
import ConfirmationModal from '@components/shared/ConfirmationModal'
import Pagination from '@components/shared/Pagination'
import CollectionsToolbar from '@components/collection/CollectionsToolbar'
import './Collections.css'

export const Collections = () => {
    
    const vm = useCollectionsViewModel()
    
    return (
        
        <div className="Collections relative">
            
            <CollectionsToolbar vm={vm} />
            
            <IndeterminateLoadingBar
                className="!h-1 rounded"
                isLoading={vm.loading}
                colorClass="bg-base-200/50"
                altColorClass="bg-base-300/50" />
            
            {!vm.hasCollections && (
                <div className="mt-20 mx-auto text-center">
                    <p>No collections match your results.</p>
                </div>
            )}
            
            {vm.hasCollections && (
                <div
                    ref={vm.refCollectionsTable}
                    className="table-responsive collections-list-viewport ml-0 pt-0 pl-0 pr-0">
                    <table className="table table-nowrap card-table table-pin-rows">
                        <thead>
                            <tr>
                                <th className="pl-1 pr-0">
                                    <Checkbox
                                        checked={vm.allChecked}
                                        indeterminate={vm.someChecked}
                                        disabled={vm.isDeletingCollections}
                                        onChange={vm.toggleAllChecked} />
                                </th>
                                <th>
                                    <a href="#!" className="text-muted sort" data-sort="collectionName">
                                        Name
                                    </a>
                                </th>
                                {vm.filteredCollections?.rows?.[0]?.documentsCount !== undefined && (
                                    <th className="md:table-cell">DOCUMENTS</th>
                                )}
                                {vm.isParseAdmin && (
                                    <th
                                        className="hidden md:table-cell"
                                        title="Collection owner (only visible to admins)">
                                        Created By
                                    </th>
                                )}
                                <th className="hidden md:table-cell">County Name</th>
                                <th className="hidden md:table-cell">State Name</th>
                                <th>
                                    {/* Actions */}
                                    {/* <div {...createCollectionHover} className="shrink-0">
                                        <button
                                        className="btn btn-sm btn-primary"
                                        onClick={showAddNewCollectionDialog}
                                        disabled={!createCollection}
                                        >
                                        Add New Collection
                                        </button>
                                    </div> */}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="list">
                            {vm.filteredCollections?.count > 0 &&
                                vm.filteredCollections.rows.map(collection =>
                                    !collection?.id ? null : (
                                        <CollectionsRow
                                            key={collection?.id}
                                            userId={vm.user?.id}
                                            isParseAdmin={vm.isParseAdmin}
                                            collection={collection}
                                            setEditCollectionDialogOpen={vm.setEditCollectionDialogOpen}
                                            setDeleteCollectionDialogOpen={vm.setDeleteCollectionDialogOpen}
                                            setEditCollection={vm.setEditCollection}
                                            setDeleteCollection={vm.setDeleteCollection}
                                            showHideAssignToUser={vm.showHideAssignToUser}
                                            hasChecked={vm.hasChecked}
                                            toggleChecked={vm.toggleChecked}
                                            isDeletingCollections={vm.isDeletingCollections} />
                                    ),
                                )}
                        </tbody>
                    </table>
                    
                    <div className="py-4 col-12">
                        <Pagination
                            className="flex justify-center w-full"
                            count={vm.collections?.count}
                            itemsPerPage={vm.collectionsPerPage}
                            onPageChange={e => {
                                vm.setPageIndex(e.selected)
                                vm.scrollTopCollections()
                            }}
                            setPageIndex={vm.setPageIndex}
                            forcePage={vm.pageIndex} />
                    </div>
                </div>
            )}
            
            {vm.editCollectionDialogOpen && (
                <CollectionRunsheetPersistFlow
                    setEditDialogOpen={vm.setEditCollectionDialogOpen}
                    initialData={vm.editCollection}
                    initialStep={STEPS.COLLECTION} />
            )}
            
            {vm.showAssignToUser && (
                <AssignCollectionToUser
                    showAdd={vm.showAssignToUser}
                    showHideAdd={vm.handleShowHideAssignToUser}
                    collection={vm.editCollection}
                    selectedModelIds={vm.assignCollections.map(({ id }) => id || '')} />
            )}
            
            <ConfirmationModal
                className="DeleteCollectionConfirmationModal !max-w-[36vw]"
                confirmButtonClass="btn-error"
                showModal={vm.deleteCollectionDialogOpen}
                showHideModal={vm.setDeleteCollectionDialogOpen}
                title={`Delete collection${vm.checked?.length > 1 ? 's' : ''}`}
                message={<>
                    <p>Are you sure you want to delete these collections?</p>
                    <ul className="list-disc ml-5 my-4">
                        {vm.collectionsMarkedForDelete.map(it => (
                            <li key={it.id}>{it.name}</li>
                        ))}
                    </ul>
                    <p className="mt-3 text-warning">
                        <i>This action cannot be undone.</i>
                    </p>
                </>}
                confirmButtonText="Delete Collections"
                onConfirm={vm.checked?.length ? vm.handleDeleteMultiple : vm.handleDelete}/>
        
        </div>
        
    )
    
}
